import { Pipe, PipeTransform } from '@angular/core';
import { ValidationMessageService } from '@app/forms/validation-message.service';

@Pipe({
  name: 'firstError',
  pure: true,
  standalone: true,
})
export class FirstErrorPipe implements PipeTransform {
  public constructor(private validationMessageService: ValidationMessageService) {}

  public transform(value: { [key: string]: boolean | string }): string {
    const firstKey = Object.keys(value ?? {})[0];
    const fallback = typeof value?.[firstKey] === 'string' ? (value[firstKey] as string) : '';

    return this.validationMessageService.getErrorMessage(firstKey) ?? fallback;
  }
}
